'use strict'

// replace import 'babel-polyfill'
import "core-js/stable"
import moment from 'moment'
import UIKit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import { createRouter, createWebHistory } from 'vue-router'
import VueCookies from 'vue-cookies'
import App from './App.vue'

// import VeeValidate from 'vee-validate'
import { createApp } from "vue";
// import VueCookie from 'vue-cookie'

import ArticlePage from './layouts/ArticlePage.vue'
import Book from './layouts/Book.vue'
import Donate from './layouts/Donate.vue'
import FeaturePage  from './layouts/FeaturePage.vue'
import Fellowship from './layouts/Fellowship.vue'
import Fellows from './layouts/Fellows.vue'
import Fellow from './layouts/Fellow.vue'
import HomePage from './layouts/HomePage.vue'
import LessonPlans from './layouts/LessonPlans.vue'
import Newsroom from './layouts/Newsroom.vue'
import Museum from './layouts/Museum.vue'
import Page from './layouts/Page.vue'
import People from './layouts/People.vue'
import PeopleFullCard from './layouts/PeopleFullCard.vue'
import Projects from './projects/Projects.vue'
import Promo from './layouts/Promo.vue'
import Person from './layouts/Person.vue'
import Photos from './layouts/Photos.vue'
import Team from './layouts/Team.vue'
import Videos from './layouts/Videos.vue'

import FloatingBadge  from './components/FloatingBadge.vue'
import FollowLinks from './components/FollowLinks.vue'
import Testimonials from './components/Testimonials.vue'

// TODO: See if necessary
import KeyboardSlide from './directives/KeyboardNav.js'
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'

UIKit.use(Icons)


// Instantiate vue app

const app = createApp(App)

// 
// GraphQL Settings
// 

// HTTP connection to the API
const httpLink = createHttpLink({
  uri: '/graphql'
})

// Create the apollo client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

import { createApolloProvider } from '@vue/apollo-option'

const apolloProvider = createApolloProvider({
  defaultClient: apolloClient,
})


// Vue.use(SocialSharing)
// Vue.use(
    // VueCookie,
    // VeeValidate,
    // VueApollo
// )
// Vue.config.productionTip = false

// 
// Register Layout Components
// 

app.component('Book', Book)
app.component('Donate', Donate)
app.component('ArticlePage', ArticlePage)
app.component('FeaturePage', FeaturePage)
app.component('Fellow', Fellow)
app.component('Fellows', Fellows)
app.component('Fellowship', Fellowship)
app.component('FloatingBadge', FloatingBadge)
app.component('HomePage', HomePage)
app.component('LessonPlans', LessonPlans)
app.component('Museum', Museum)
app.component('Newsroom', Newsroom)
app.component('Page', Page)
app.component('People', People)
app.component('PeopleFullCard', PeopleFullCard)
app.component('Person', Person)
app.component('Photos', Photos)
app.component('Projects', Projects)
app.component('Promo', Promo)
app.component('Testimonials', Testimonials)
app.component('Team', Team)
app.component('Videos', Videos)
app.component('FollowLinks', FollowLinks)

// 
// Router Configuation
// 

import { routes } from './routes';

const router = createRouter({
    // TODO: Verify if this or createWebHashHistory
    history: createWebHistory(),
    base: '/',
    routes
})

router.beforeEach(function (to, from, next) {
    setTimeout(() => {
        window.scrollTo(0, 0)
    }, 10)
    next()
})

// router.afterEach(function (to, from) {
//
// })

// 
// Configure store
// 


// watch: {
//     'store.MetaTitle': function(newTitle, oldTitle) {
//         console.log("Now changed")
//     }
// }

// 
// Configure vue instance providers & mount
// 
const width = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;

app.use(router)
app.use(apolloProvider)
app.use(VueCookies)
app.provide('moment', moment)

import state from "./state"
if(document.body.attributes["data-theme"]) {
  app.provide('theme', document.body.attributes["data-theme"].nodeValue)
}
app.provide('state', state)
app.provide('$width', width)

app.directive('keyboard-slide', KeyboardSlide)

app.mount("app")